import * as THREE from "three";
import Experience from "../Experience.js";

export default class Cat {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.group = this.experience.group;
    this.sizes = this.experience.sizes;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("cat");
    }

    // Resource
    this.resource = this.resources.items.catModel;
    this.isPeach = true;
    this.socksColor = this.resources.items.socksBaseColor;
    this.socksColor.flipY = false;
    this.socksColor.colorSpace = THREE.SRGBColorSpace;
    this.orm = this.resources.items.peachORM;
    this.socksMaterial = new THREE.MeshStandardMaterial({
      map: this.socksColor,
      aoMap: this.orm,
    });

    this.peachColor = this.resources.items.peachBaseColor;
    this.peachColor.flipY = false;
    this.peachColor.colorSpace = THREE.SRGBColorSpace;
    this.peachMaterial = new THREE.MeshStandardMaterial({
      map: this.peachColor,
      aoMap: this.orm,
    });

    this.setModel();
    this.setAnimation();
  }

  setModel() {
    this.model = this.resource.scene;

    this.group.addModel(this.model);

    this.model.traverse((child) => {
      if (child.isSkinnedMesh) {
        child.castShadow = true;
        child.receiveShadow = false;
        child.frustumCulled = false;
      }
    });
  }
  updateTexture() {
    if (this.isPeach) {
      this.model.traverse((child) => {
        if (child.isSkinnedMesh) {
          child.material = this.socksMaterial;
        }
      });
    } else {
      this.model.traverse((child) => {
        if (child.isSkinnedMesh) {
          child.material = this.peachMaterial;
        }
      });
    }
    this.isPeach = !this.isPeach;
  }
  setAnimation() {
    this.animation = {};

    // Mixer
    this.animation.mixer = new THREE.AnimationMixer(this.model);

    // Actions (looked up by clip name so GLB export order doesn't matter)
    const action = (name) =>
      this.animation.mixer.clipAction(
        THREE.AnimationClip.findByName(this.resource.animations, name),
      );
    this.animation.idles = {
      shelf: action("Idle1"),
      desk: action("Idle2"),
      floor: action("Idle3"),
    };
    // jumps[i] goes from spots[i] down to spots[i + 1]
    this.animation.jumps = [action("JumpToDesk"), action("JumpToFloor")];
    for (const jump of this.animation.jumps) {
      jump.setLoop(THREE.LoopOnce);
      jump.clampWhenFinished = true;
    }

    // The cat moves down through these spots, one jump at a time. It only
    // goes down: there are no jump-up clips, and reversing a jump looks wrong.
    this.spots = ["shelf", "desk", "floor"];
    this.spot = "shelf";
    this.transition = null; // { jump, to } while a jump is playing

    this.animation.idles.shelf.play();

    this.animation.mixer.addEventListener("finished", (event) => {
      if (!this.transition || event.action !== this.transition.jump) return;

      const { jump, to } = this.transition;
      this.transition = null;
      this.spot = to;

      if (to === "desk") this.turnMonitorOn();

      const idle = this.animation.idles[to];
      idle.reset().play();
      idle.crossFadeFrom(jump, 0.1, true);
    });
  }

  turnMonitorOn() {
    const monitor = this.experience.world.room.screenMaterial;
    monitor.color = new THREE.Color(0xffffff);
    monitor.emissiveIntensity = 0.2;
    this.experience.world.environment.rectLight.intensity = 1;
  }

  targetSpot() {
    const scroll = this.sizes.scrollValue;
    if (scroll >= 1.5) return "floor";
    if (scroll >= 0.6) return "desk";
    return "shelf";
  }

  // Start the jump from the current spot down to the next one
  jumpDown() {
    const from = this.spots.indexOf(this.spot);
    const jump = this.animation.jumps[from];

    jump.reset().play();
    jump.crossFadeFrom(this.animation.idles[this.spot], 0.1, false);

    this.transition = { jump, to: this.spots[from + 1] };
  }

  update() {
    this.animation.mixer.update(this.time.delta * 0.001);

    const target = this.spots.indexOf(this.targetSpot());
    if (!this.transition && target > this.spots.indexOf(this.spot)) {
      this.jumpDown();
    }
  }
}

/*****Anim frames + names
 * -80 - 0 - Idle1
 * 0 - 65 - JumpToDesk
 * 66 - 130 Idle2
 * 131- 325 - JumpToFloor  
 * 325 - 400 - Idle3
 * 
 * Mobile
  * -80 - 0 - Idle1
 * 0 - 65 - JumpToDesk
 * 66 - 130 Idle2
 * 131- 302 - JumpToFloor  
 * 303 - 380
 - Idle3 
 *  */
